import { render, staticRenderFns } from "./Magistrados.vue?vue&type=template&id=04174cce"
import script from "./Magistrados.vue?vue&type=script&lang=js"
export * from "./Magistrados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports